/* import __COLOCATED_TEMPLATE__ from './tag-drop-header.hbs.js'; */
import { classNames } from "@ember-decorators/component";
import ComboBoxSelectBoxHeaderComponent from "select-kit/components/combo-box/combo-box-header";
const TagDropHeader = dt7948.c(class TagDropHeader extends ComboBoxSelectBoxHeaderComponent {}, [classNames("tag-drop-header")]);
export default TagDropHeader;